var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIran(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 8h30v8H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d9e4a",
    d: "M30 8H0V0h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c92a1d",
    d: "M30 24H0v-8h30zM17.06 12.8a3.1 3.1 0 0 0-.93-3.33 3.43 3.43 0 0 1-.83 4.69l.1-2.56V9.59q-.25-.12-.4-.35-.15.23-.4.35v2.01l.1 2.56a3.43 3.43 0 0 1-.82-4.7 3.13 3.13 0 0 0 .58 5.15 3 3 0 0 1-1.34.2q.8.25 1.61.09v.1l.27.37.27-.36v-.11a3 3 0 0 0 1.61-.09 4 4 0 0 1-1.34-.2 3 3 0 0 0 1.52-1.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c92a1d",
    d: "M18.08 10.63a2.6 2.6 0 0 0-1.63-1.23 3.43 3.43 0 0 1 .68 4.8l-.01.01a2.6 2.6 0 0 0 .96-3.58M13.55 9.4a2.62 2.62 0 0 0-.67 4.81 3.43 3.43 0 0 1 .67-4.8m.76-.18A.5.5 0 0 0 15 9.1a.5.5 0 0 0 .86-.47.47.47 0 0 1-.86.15.47.47 0 0 1-.86-.15.5.5 0 0 0 .17.59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIran);
export default __webpack_public_path__ + "static/media/iran.a410ac7a19ae06a2577fcdd7bb22ad96.svg";
export { ForwardRef as ReactComponent };